import React from 'react';
import ButtonsSearch from '../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import InputCheckBox from '../../../../../../../components/NovoSistema/InputCheckBox';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ConsultaDeMovimentacaoSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputDate title="Período Inicial" id="PeriodoInicial" widthPercentage="20%" />
          <InputDate title="Período Final" id="PeriodoFinal" widthPercentage="20%" />
          <InputText title="Nro do Documento" id="NroDoDocumento" widthPercentage="20%" />
          <InputCheckBox title="Canceladas" id="Canceladas" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Tipo de Movimentação"
            id="TipoDeMovimentacao"
            optionsArray={[
              'Todas',
              'Ajuste de Entrada',
              'Ajuste de Saída',
              'Cancelamento de Entrada',
              'Cancelamentos de Saída',
              'Devolução Entrada',
              'Devolução Saída',
              'Movimentação de Entrada',
              'Movimentação de Saída',
              'Requisição de Material',
              'Retorno',
              'Saldo Inicial',
              'Transferência Entrada',
              'Transferência Saída',
            ]}
            widthPercentage="20%"
          />
          <SelectAndOptions
            title="Tipo de documento"
            id="TipoDeDocumento"
            optionsArray={[
              '',
              '1  | NF    | Nota Fiscal',
              '1B | NFA   | Nota Fiscal Avulsa',
              '2  | NFVC  | Nota Fiscal Venda Consumidor',
              '2D | CFECF | Cupom Fiscal - ECF',
              '4  | NFP   | Nota Fiscal Produtor',
              '55 | NFE   | Nota Fiscal Eletrônica',
              '59 | CFE   | Cupom Fiscal Eletrônico - SAT',
              '65 | NFCE  | Nota Fiscal Eletrônica ao Consumidor Final - NFC-e',
              '99 | INT   | Outros - Uso Interno',
            ]}
            widthPercentage="20%"
          />
          <SelectAndOptions
            title="Origem"
            id="Origem"
            optionsArray={['Todos', 'Estoque', 'Faturamento', 'PDV', 'Produção']}
            widthPercentage="20%"
          />
          <SelectAndOptions
            title="Emitido para"
            id="EmitidoPara"
            optionsArray={['Todos', 'Matriz/Final', 'Terceiros']}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Tipo de Pessoa"
            id="TipoDePessoa"
            optionsArray={['Todas', 'Física', 'Jurídica']}
            widthPercentage="20%"
          />
          <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="20%" />
          <DoubleInput title="Empresa" id="Empresa" widthPercentage="40%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Parceiro" id="Parceiro" widthPercentage="40%" />
          <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
